import { gql } from '@apollo/client';

export const INTRANEX_APP_VERSION_PUBLISHED_SUBSCRIPTION = gql`
  subscription {
    intranexAppVersionPublished
  }
`;
